import { render, staticRenderFns } from "./Kudo.vue?vue&type=template&id=7d818470&"
import script from "./Kudo.vue?vue&type=script&lang=js&"
export * from "./Kudo.vue?vue&type=script&lang=js&"
import style0 from "./Kudo.vue?vue&type=style&index=0&id=7d818470&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports